import {Component} from '@angular/core';

@Component({
  selector: 'bor-contact',
  standalone: false,
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent {}
